<template>
  <div class="equipment-create p-6">
    <h1 class="text-2xl font-bold mb-4">Add New Equipment</h1>
    <div
      v-if="notification"
      class="fixed top-4 right-4 bg-green-100 text-green-800 px-4 py-2 rounded shadow"
    >
      {{ notification }}
    </div>
    <EquipmentForm
      :equipment="editingEquipment"
      :loading="formLoading"
      :showForm="true"
      @saved="handleSuccess"
      @cancel="handleCancel"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import EquipmentForm from '@/components/equipment/EquipmentForm.vue'
import { equipmentApi } from '@/api/equipmentApi'
import type { Equipment } from '@/types/equipment'

const notification = ref<string>('')
const router = useRouter()
const route = useRoute()
const editingEquipment = ref<Equipment | null>(null)
const formLoading = ref(false)

// If the page was opened with an editId query param (e.g. from EquipmentDetail.goEdit), fetch equipment
onMounted(async () => {
  const editId = route.query.editId
  if (editId) {
    const idNum = Number(editId)
    if (!Number.isNaN(idNum)) {
      formLoading.value = true
      try {
        editingEquipment.value = await equipmentApi.getById(idNum)
      } catch (err) {
        console.error('Failed to load equipment for editing:', err)
        notification.value = 'Failed to load equipment for editing.'
      } finally {
        formLoading.value = false
      }
    }
  }
})

function handleSuccess() {
  notification.value = 'Equipment saved successfully!'
  setTimeout(() => {
    notification.value = ''
    router.push({ name: 'EquipmentView' }) // Redirect to equipment list view
  }, 1200)
}

function handleCancel() {
  notification.value = 'Action cancelled.'
  setTimeout(() => {
    notification.value = ''
    router.push({ name: 'EquipmentView' }) // Redirect to equipment list view
  }, 1000)
}
</script>
